import './App.css';
import 'antd/dist/reset.css';
import { EquityPenetration } from './components';

function App() {
  return (
    <div className="App">
      <EquityPenetration />
    </div>
  );
}

export default App;
